import { RadioButton, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';

export interface RadioButtonFieldRules {
  disabled?: boolean;
}

export interface RadioButtonFieldProps {
  name: string;
  value: string;
  label?: string;
  rules?: RadioButtonFieldRules;
  TokenTextAppearance?: TokenTextAppearance;
  onChange?(e: React.SyntheticEvent<HTMLElement>): void;
}

export function RadioButtonField({ value, name, rules, onChange, ...rest }: RadioButtonFieldProps): ReactElement {
  const { control } = useFormContext();
  const {
    field: { value: fieldValue, onChange: onFieldChange, onBlur },
  } = useController({
    name,
    control,
  });

  return (
    <RadioButton
      name={name}
      value={value}
      onBlur={onBlur}
      onChange={(e) => {
        onFieldChange(e);
        onChange?.(e);
      }}
      checked={fieldValue === value}
      {...rules}
      {...rest}
    />
  );
}
